import { apiCredentials } from "./apiManager";

import { apiStaticDataUrls } from "config/endPoints";
import {
  initializeTerms,
  initializeAttachmentTypes,
  initializeLanguages,
} from "store/staticDataActions";

import { accountInitialize } from "store/accountActions";

const normalize = (code) => (code || "").split("-")[0].toLowerCase();
const urlLangSeg = () => window.location.pathname.split("/")[1]?.toLowerCase();

const staticDataManager = (store) => {
  const { dispatch } = store;
  termsLoader(dispatch);
  attachmentTypesLoader(dispatch);
  languagesLoader(store);
};

export const termsLoader = (dispatch) => {
  apiCredentials
    .get(apiStaticDataUrls.API_GET_TERMS)
    .then((response) => {
      if (response.data.isSuccess && response.data.data) {
        dispatch(initializeTerms({ terms: response.data.data }));
      }
    })
    .catch(function (error) {
      console.log("staticDataManager-termsLoader-error: ", error);
    });
};

const attachmentTypesLoader = (dispatch) => {
  apiCredentials
    .get(apiStaticDataUrls.API_GET_ATTACHMENTTYPES)
    .then((response) => {
      if (response.data.isSuccess && response.data.data) {
        dispatch(
          initializeAttachmentTypes({ attachmentTypes: response.data.data })
        );
      }
    })
    .catch(function (error) {
      console.log("staticDataManager-attachmentTypesLoader-error: ", error);
    });
};

const languagesLoader = (store) => {
  const { dispatch, getState } = store;

  apiCredentials
    .get(apiStaticDataUrls.API_GET_LANGUAGES)
    .then((response) => {
      if (response.data.isSuccess && response.data.data) {
        const langs = response.data.data;
        dispatch(initializeLanguages({ languages: langs }));
        initializeAccount(langs, dispatch, getState);
      }
    })
    .catch((error) =>
      console.log("staticDataManager-languagesLoader-error: ", error)
    );
};

const initializeAccount = (languages, dispatch, getState) => {
  const state = getState();
  const current = state.account?.language;
  const seg = urlLangSeg();

  const langFromUrl = seg
    ? languages.find((l) => normalize(l.code) === seg)
    : null;

  let defaultLang = languages.find((l) => l.isDefault) || languages[0];

  const chosen = langFromUrl || current || defaultLang;

  if (!chosen) return;
  if (state.account?.language?.code === chosen.code) return;

  dispatch(
    accountInitialize({
      language: chosen,
      settings: { popUpTermDismissed: false },
    })
  );
};
export default staticDataManager;

const loadTerms = (selector, term) => {
  const { language } = selector.account;
  const { terms } = selector.staticData;
  let entity = terms
    ? terms.find((le) => {
        return le.keyName === term;
      })
    : null;
  let localization = extractLocalizedTerms(entity, language);
  if (localization) return localization;
  return term;
};

const extractLocalizedTerms = (entity, language) => {
  if (entity && entity.localizedTerms) {
    let term = language
      ? entity.localizedTerms.find((lt) => {
          return lt.languageId === language.languageId;
        })
      : entity.localizedTerms[0];
    if (term) return term.termValue;
  }
};

const findAttachmentType = (attachmentTypes, mimeType) => {
  try {
    let result = attachmentTypes
      ? attachmentTypes.find((at) => {
          return at.mimeType === mimeType;
        })
      : null;
    // console.log('findAttachmentType-attachmentTypes, mimeType, result: ', attachmentTypes, mimeType, result);
    return result;
  } catch (e) {
    console.log("staticDataManager-findAttachmentType-error: ", e);
    return null;
  }
};

export const staticData = { loadTerms, findAttachmentType };
